import React from 'react';
import { primaryColorOrDefault, textColorOrDefault } from '../../../reducers';
import { connect } from 'react-redux';
import styles from './CreateGroupEntry.scss';
import CreatGroup from '../../../icons/dist/components/createGroup';

interface CreateGroupEntryProps {
  title: string;
  onCreateGroupClicked: any;
  primaryColor: string;
  textColor: string;
}

class CreateGroupEntry extends React.Component<CreateGroupEntryProps> {
  render() {
    const { title, primaryColor, textColor, onCreateGroupClicked } = this.props;

    return (
      <div
        className={styles.entry}
        data-hook="create-group-chat"
        onClick={onCreateGroupClicked}
      >
        <div className={styles.icon} data-hook="icon">
          <CreatGroup size="36px" style={{ color: primaryColor }} />
        </div>
        <span
          className={styles.title}
          data-hook="title"
          style={{ color: primaryColor }}
        >
          {title}
        </span>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    primaryColor: primaryColorOrDefault(state),
    textColor: textColorOrDefault(state),
  };
}

export default connect(mapStateToProps)(CreateGroupEntry);
